import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mp-badge-updates',
  templateUrl: './badge-updates.component.html',
  styleUrl: './badge-updates.component.scss',
  host: {
    'class': 'mp-badge-updates',
    '[class.mp-badge-updates--active]': 'updated() > 0',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class BadgeUpdatesComponent {
  readonly available: InputSignal<number> = input<number>(0);
  readonly updated: InputSignal<number> = input<number>(0);
}
